import React from 'react'
import { Select as UISelectField, MenuItem, InputLabel, FormControl, FormHelperText, ListSubheader } from '@material-ui/core'

const SelectField = ({ label, id, items, value, onChange, error, required, errorMessage, style, ...props }) => {

  return (
    <div>
      <FormControl required={required} variant="filled" style={{ width: '100%', height: '100%', ...style }} error={error}>
        <InputLabel id={`label-for-${id}`}>{label}</InputLabel>
        <UISelectField
          labelId={`label-for-${id}`}
          id={id}
          value={value}
          onChange={onChange}
          defaultValue=""
          {...props}
          {...style}
        >
          {
            items.map((item, index) => (
              item.subheader 
              ? <ListSubheader disableSticky>{item.name}</ListSubheader>
              : <MenuItem key={index} value={item.value} name={item.name}>{item.name}</MenuItem>
            ))
          }
        </UISelectField>
        {
          error && <FormHelperText>{errorMessage}</FormHelperText>
        }
      </FormControl>
    </div>
  )
}

SelectField.defaultProps = {
  label: '',
  id: '',
  items: [],
  value: '',
  onChange: () => {},
  error: false,
  errorMessage: ''
}

export default SelectField